<i18n src="./resources/locales.json"></i18n>

<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form ref="measureForm" v-model="isValid">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="required-field"
                  v-model="measure.name"
                  :label="$t('name')"
                  :rules="[nameRules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" :disabled="!isValid" @click="save">
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'MeasureDetailModal',

  data() {
    return {
      isValid: false,
      measure: {},
      dialog: false,
      defaultMeasure: {
        id: '-1',
        unitOfMeasure: '',
        name: ''
      }
    };
  },

  computed: {
    formTitle() {
      const { id } = this.measure;
      return id === '-1' ? this.$t('newMeasure') : this.$t('editMeasure');
    },

    nameRules() {
      return { required: value => !!value || this.$t('nameIsRequired') };
    }
  },

  methods: {
    ...mapActions('spareParts', ['addMeasure', 'updateMeasure']),

    open(measureToUpsert) {
      this.measure = Object.assign({}, measureToUpsert);
      this.dialog = true;
    },

    close() {
      this.resetValidations();
      this.isValid = false;
      this.measure = Object.assign({}, this.defaultMeasure);
      this.dialog = false;
    },

    async save() {
      const { id } = this.measure;
      this.measure = Object.assign({}, this.measure);

      if (id !== '-1') {
        try {
          await this.updateMeasure(this.measure);
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: this.$t('measureInfoWasUpdatedSuccessfully'),
                messageType: 'success'
              }
            )
          );
        } catch (error) {
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: this.$t('errorWhileUpdatingMeasureInfoPleaseTryAgain'),
                messageType: 'error'
              }
            )
          );
        }
      } else {
        try {
          await this.addMeasure(this.measure);
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: `${this.$t('theMeasure')} ${
                  this.measure.name
                } ${this.$t('wasCreatedSuccessfully')}`,
                messageType: 'success'
              }
            )
          );
        } catch (error) {
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: this.$t('errorWhileCreatingTheMeasure'),
                messageType: 'error'
              }
            )
          );
        }
      }

      this.close();
    },

    resetValidations() {
      this.$refs.measureForm.resetValidation();
    }
  }
};
</script>
